import { FEATURES_PAGE } from "@/lib/constants";
import { Check } from "lucide-react";

export default function MobileAppSection() {
  const { mobileApp } = FEATURES_PAGE;

  return (
    <section
      data-testid="feature-section-mobile-app"
      className="bg-[#20611B] py-12 md:py-20"
      aria-label="Mobile App"
    >
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl text-center">
        <span
          className="text-xs font-bold uppercase tracking-widest text-[#D4A84B] block mb-4"
          data-testid="feature-label-mobile-app"
        >
          {mobileApp.label}
        </span>

        <h2
          className="font-heading text-3xl md:text-4xl font-bold text-white leading-tight tracking-tight mb-6"
          data-testid="feature-heading-mobile-app"
        >
          {mobileApp.heading}
        </h2>

        <p className="text-white/80 text-base leading-relaxed max-w-2xl mx-auto mb-8">
          {mobileApp.body}
        </p>

        <ul className="space-y-3 max-w-md mx-auto mb-12 text-left">
          {mobileApp.bullets.map((bullet, i) => (
            <li
              key={i}
              className="flex items-start gap-3"
              data-testid={`feature-bullet-mobile-app-${i}`}
            >
              <span className="inline-flex items-center justify-center w-5 h-5 rounded-full bg-[#D4A84B] shrink-0 mt-0.5">
                <Check className="h-3 w-3 text-white" />
              </span>
              <span className="text-sm text-white">{bullet}</span>
            </li>
          ))}
        </ul>

        {/* Phone mockups */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-6 md:gap-10">
          {mobileApp.phonePlaceholders.map((label, i) => (
            <div key={i} className="w-52" data-testid={`mobile-mockup-${i}`}>
              {/* Phone frame */}
              <div className="bg-[#1A1A1A] rounded-[2.5rem] p-2.5 shadow-2xl border border-gray-700">
                {/* Notch */}
                <div className="relative">
                  <div className="absolute top-0 left-1/2 -translate-x-1/2 w-20 h-5 bg-[#1A1A1A] rounded-b-xl z-10" />
                  <div className="bg-white rounded-[2rem] aspect-[9/19] flex flex-col items-center justify-center overflow-hidden">
                    {/* Status bar */}
                    <div className="absolute top-0 left-0 right-0 h-7 bg-gray-50 flex items-center justify-between px-6 text-[8px] text-gray-400 rounded-t-[2rem]">
                      <span>9:41</span>
                      <span></span>
                    </div>
                    <p className="text-xs text-[#6B7280] text-center px-4 leading-relaxed">{label}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
